import { Component } from '@builder.io/sdk';

export const config: Component = {
    name: 'Toggle',
    inputs: [
        {
            name: 'stateKey',
            type: 'string',
            required: true,
            defaultValue: 'showMonthlyPrice',
            helperText: 'The key of the state to toggle in Builder.io',
        },
        {
            name: 'label1',
            type: 'string',
            required: true,
            defaultValue: 'Monthly',
            helperText: 'Label for the first option.',
        },
        {
            name: 'label2',
            type: 'string',
            required: true,
            defaultValue: 'Annual',
            helperText: 'Label for the second option.',
        },
        {
            name: 'extraMessage',
            type: 'string',
            required: false,
            defaultValue: 'SAVE UP TO 40%',
            helperText: 'Optional extra message to display.',
        },
    ],
};
